import { hasSubscriptionFlag } from '@/data/flags/local-flags';
import { activeSubHasPurchasedProductLine } from '@/data/flags/product-lines.js';
import { FREEMIUM_STATUS } from '@/voc/constants/constants';

export function hasExploreEnabled () {
    const hasPurchasedExplore = activeSubHasPurchasedProductLine('voc', 'explore');
    const hasExploreSettingsEnabled = activeSubHasPurchasedProductLine('voc', 'exploreSettings.enabled');
    const canEnableExplore = !hasSubscriptionFlag('doNotProcessGoogleGenAi');

    return (hasPurchasedExplore || hasExploreSettingsEnabled) && canEnableExplore && !hasFreemiumEnabled();
}

export function hasSetupExplore () {
    if (!hasSubscriptionFlag('enableListenAIInsights')) return false;

    // voc.explore is the legacy flag - we now use exploreSettings, but check this to make sure
    // we don't mess up existing customers
    if (activeSubHasPurchasedProductLine('voc', 'explore')) return true;

    const syncComplete = activeSubHasPurchasedProductLine('voc', 'exploreSettings.initialSyncCompleted');
    const exploreSettingsEnabled = activeSubHasPurchasedProductLine('voc', 'exploreSettings.enabled');

    if (syncComplete && exploreSettingsEnabled) return true;

    return false;
};

export function hasFreemiumEnabled () {
    const hasFreemiumEnabled = activeSubHasPurchasedProductLine('voc', 'freemium.enabled');
    const canEnableFreemium = !hasSubscriptionFlag('doNotProcessGoogleGenAi');
    const hasAskPendo = hasSubscriptionFlag('askPendo');

    return hasFreemiumEnabled && canEnableFreemium && hasAskPendo;
}

export function freemiumStatus () {
    if(!hasFreemiumEnabled()) return FREEMIUM_STATUS.DISABLED;

    const syncComplete = activeSubHasPurchasedProductLine('voc', 'exploreSettings.initialSyncCompleted');
    if(syncComplete) return FREEMIUM_STATUS.READY;

    const isProcessing = activeSubHasPurchasedProductLine('voc', 'freemium.onboardingCompleted');
    if(isProcessing) return FREEMIUM_STATUS.PROCESSING;

    return FREEMIUM_STATUS.ENABLED;
}

export function hasDiscoverAIAccess () {
    if (!activeSubHasPurchasedProductLine('voc', 'feedback')) return false;

    const hasOpenAiDiscover = hasSubscriptionFlag('enableOpenAIDiscoverAI');
    const hasGoogleListenSummaries = hasSubscriptionFlag('enableGoogleListenSummariesAI');

    if (hasOpenAiDiscover || hasGoogleListenSummaries) return true;

    return false;
}

export function hasOpenAISummaryAccess () {
    if (!activeSubHasPurchasedProductLine('voc', 'feedback')) return false;

    return hasSubscriptionFlag('enableOpenAIDiscoverAI');
}
